import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=2a2a5942&scoped=true&"
import script from "./PrivacyPolicy.js?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.js?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.scss?vue&type=style&index=0&id=2a2a5942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a5942",
  null
  
)

export default component.exports